import apisauce from 'apisauce';

const apiMonitor = response => console.log('api response', response);

// our "constructor"
const create = (baseURL = process.env.REACT_APP_AUTH_API_URL) => {
  // ------
  // STEP 1
  // ------
  //
  // Create and configure an apisauce-based api object.
  //
  const api = apisauce.create({
    // base URL is read from the "constructor"
    baseURL,
    // here are some default headers
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/json',
      'Accept-Token-Algorithm': 'RS256',
    },
    // 10 second timeout...
    timeout: 10000,
  });

  if (process.env.NODE_ENV !== 'production') {
    api.addMonitor(apiMonitor);
  }

  // ------
  // STEP 2
  // ------
  //
  // Define some functions that call the api.  The goal is to provide
  // a thin wrapper of the api layer providing nicer feeling functions
  // rather than "get", "post" and friends.
  //
  // I generally don't like wrapping the output at this level because
  // sometimes specific actions need to be take on `403` or `401`, etc.
  //
  // Since we can't hide from that, we embrace it by getting out of the
  // way at this level.
  //
  const setAuthToken = access_token =>
    api.setHeaders({Authorization: `Bearer ${access_token}`});

  const removeAuthToken = () => api.setHeader('Authorization', null);

  const setLanguage = id =>
    api.setHeaders({'Content-Language': id});

  const login = ({phone, password}) =>
    api.post('sms/Login', {phone, password});

  const refreshToken = refreshToken =>
    api.post('Refresh', {refreshToken});
    //api.get(`Refresh/${refreshToken}`);

  const getNewPassword = phone =>
    api.post('sms/RequestResetPassword', phone);

  // ------
  // STEP 3
  // ------
  //
  // Return back a collection of functions that we would consider our
  // interface.  Most of the time it'll be just the list of all the
  // methods in step 2.
  //
  // Notice we're not returning back the `api` created in step 1?  That's
  // because it is scoped privately.  This is one way to create truly
  // private scoped goodies in JavaScript.
  //
  return {
    // a list of the API functions from step 2
    setAuthToken,
    removeAuthToken,
    setLanguage,
    login,
    refreshToken,
    getNewPassword,
  };
};

// let's return back our create method as the default.
export default {
  create,
};
